import { create } from "zustand";

const useMenuStore = create((set) => ({
  menus: {},

  // Function to open a specific menu
  openMenu: (menuId, anchorElement) => {
    set((state) => ({
      menus: {
        ...state.menus,
        [menuId]: { open: true, anchorElement },
      },
    }));
  },

  // Function to close a specific menu
  closeMenu: (menuId) => {
    set((state) => ({
      menus: {
        ...state.menus,
        [menuId]: { open: false, anchorElement: null },
      },
    }));
  },

  // Function to close all menus
  closeAllMenus: () => {
    set({ menus: {} });
  },
}));

export default useMenuStore;
